<script>
  import http from '@/service/http'
  import { mapState, mapGetters } from 'vuex'
  import { ListSelect } from 'vue-search-select'
  import cloneDeep from 'lodash/cloneDeep'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        clientes: [],
        objetivos: [],
        status: [],
        motivos: [],
        pagamentos: [],
        servicos: [],
        produtos: [],
        grupos: [],
        gerar_os: false,
        status_os_id: '',
        totalOsStatus: [],
        enviar_orcamento: false,
        editorDescricao: {
          placeholder: 'Descrição',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        },
        item: {
          id: '',
          servico: '',
          qtd: '',
          valor: '',
          descricao: ''
        },
        itemProduto: {
          id: '',
          produto: '',
          valor: '',
          qtd: ''
        },
        itemCliente: {
          id: '',
          cliente: ''
        },
        itemObjetivo: {
          id: '',
          titulo: '',
          objetivo: '',
          resp_kitgas: '',
          resp_cliente: '',
          disposicoes_finais: ''
        },
        propostaIndex: 0,
        paginas: 1,
        paginas1: 1,
        paginas2: 1,
        paginas3: 1,
        paginas4: 1,
        orcamento: {
          id: '',
          cliente_id: '',
          orcamento: '',
          tipo: 1,
          cnpj: '',
          razao_social: '',
          ie: '',
          responsavel: '',
          cpf: '',
          rg: '',
          email: '',
          telefone: '',
          telefone2: '',
          telefone3: '',
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          isometrico: '',
          bairro: '',
          cidade: '',
          estado: '',
          referencia: '',
          blocos: '',
          visita: false,
          visita_data: '',
          visita_hora: '',
          status_id: 1,
          localizacao_imagem: '',
          localizacao_mapa: '',
          propostas: [],
          fotos: [],
          videos: [],
          update_cliente: false,
          os_ids: [],
          documento_assinado: '',
          motivo_id: '',
          titulo: '',
          objetivo: '',
          resp_kitgas: '',
          resp_cliente: '',
          disposicoes_finais: ''
        },
        progress: 0,
        progress2: 0,
        errorFile: false,
        errorFile2: false,
        options: {
          url: `${process.env.API_URL}/upload-image-area`,
          uploadMultiple: false,
          parallelUploads: 1,
          acceptedFiles: 'image/*',
          headers: {
            path: 'orcamentos',
            width: 800,
            height: 600,
            accept: 'all'
          }
        },
        options2: {
          url: `${process.env.API_URL}/upload-documento-assinado`,
          uploadMultiple: false,
          parallelUploads: 1,
          headers: {
            path: 'orcamento',
            accept: 'all'
          }
        },
        video: ''
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      }
    },
    methods: {
      onEditorChange ({quill, html, text}, indexProposta, indexServico, content) {
        if (this.orcamento.propostas[indexProposta].servicos[indexServico].descricao === '') {
          this.orcamento.propostas[indexProposta].servicos[indexServico].descricao = content
        }
      },
      totalProgressIsometrico (progress, totalBytes, bytesSent) {
        this.progress2 = progress
      },
      completeIsometrico (file, status, xhr) {
        if (file.errorMessage) {
          this.errorFile2 = true
        } else {
          this.errorFile2 = false
          file.addAttribute('id', xhr.response.id)
          this.orcamento.isometrico = xhr.response
          this.progress2 = 0
        }
      },
      destroyIsometrico () {
        this.$swal({
          title: 'Atenção',
          text: `deseja excluir a imagem?`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          this.orcamento.isometrico = ''
        })
      },
      setEndereco () {
        window.$.getJSON(`https://viacep.com.br/ws/${this.orcamento.cep}/json/`)
          .then(response => {
            if (!response.erro) {
              this.orcamento.logradouro = response.logradouro
              this.orcamento.bairro = response.bairro
              this.orcamento.cidade = response.localidade
              this.orcamento.estado = response.uf
              $('#numero').focus()
            } else {
              this.orcamento.logradouro = ''
              this.orcamento.numero = ''
              this.orcamento.complemento = ''
              this.orcamento.bairro = ''
              this.orcamento.cidade = ''
              this.orcamento.estado = ''
            }
            setTimeout(function () {
              window.Materialize.updateTextFields()
            }, 0)
          })
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/orcamentos/${id}/edit`)
          this.orcamento = data.orcamento
          this.status = data.status
          this.pagamentos = data.pagamentos
          this.servicos = data.servicos
          this.produtos = data.produtos
          this.clientes = data.clientes
          this.motivos = data.motivos
          this.grupos = data.grupos
          this.objetivos = data.objetivos
          this.totalOsStatus = data.totalOsStatus
          let totalPaginas = this.orcamento.os_ids.length / 30
          this.paginas = Math.ceil(totalPaginas)
          let totalPaginas1 = this.totalOsStatus[1] / 30
          this.paginas1 = Math.ceil(totalPaginas1)
          let totalPaginas2 = this.totalOsStatus[2] / 30
          this.paginas2 = Math.ceil(totalPaginas2)
          let totalPaginas3 = this.totalOsStatus[3] / 30
          this.paginas3 = Math.ceil(totalPaginas3)
          let totalPaginas4 = this.totalOsStatus[4] / 30
          this.paginas4 = Math.ceil(totalPaginas4)
        } else {
          const {data} = await http.get(`/orcamentos/create`)
          this.status = data.status
          this.pagamentos = data.pagamentos
          this.servicos = data.servicos
          this.produtos = data.produtos
          this.clientes = data.clientes
          this.motivos = data.motivos
          this.grupos = data.grupos
          this.objetivos = data.objetivos
        }
        setTimeout(function () {
          $('.collapsible').collapsible()
          $('.collapsible').collapsible('close', 0)
          $('.collapsible').collapsible('close', 1)
          $('.collapsible').collapsible('close', 2)
          $('.collapsible').collapsible('close', 3)
          $('.collapsible').collapsible('open', 0)
          window.Materialize.updateTextFields()
        }, 0)
      },
      validate () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            let msg = ''
            this.errors.items.forEach((item) => {
              msg += item.msg + '<br>'
            })
            this.$swal({
              title: 'Ops, encontramos um erro!',
              html: msg,
              type: 'error',
              cancelButtonText: 'Ok'
            })
            return false
          }
          if (this.orcamento.status_id === 5) {
            if (this.orcamento.cliente_id === '' && this.orcamento.tipo === 1 && (this.orcamento.cnpj === '' || this.orcamento.responsavel === '' || this.orcamento.razao_social === '')) {
              this.$swal({
                title: 'Ops, encontramos um erro!',
                html: 'Campos Responsável, Razão Social e CNPJ são obrigatórios para aprovação desse orçamento',
                type: 'error',
                cancelButtonText: 'Ok'
              })
              return false
            }
            if (this.orcamento.cliente_id === '' && this.orcamento.tipo === 2 && (this.orcamento.cpf === '' || this.orcamento.responsavel === '')) {
              this.$swal({
                title: 'Ops, encontramos um erro!',
                html: 'Campos Responsável e CPF sãp obrigatórios para aprovação desse orçamento',
                type: 'error',
                cancelButtonText: 'Ok'
              })
              return false
            }
            var propostasAprovadas = 0
            this.orcamento.propostas.forEach((item) => {
              if (item.aprovado === true) {
                propostasAprovadas++
              }
            })
            if (propostasAprovadas === 0) {
              this.$swal({
                title: 'Ops, encontramos um erro!',
                html: 'O status aprovado requer ao menos uma proposta aprovada',
                type: 'error',
                cancelButtonText: 'Ok'
              })
              return false
            }
          }
          this.submit()
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/orcamentos' : `/orcamentos/${this.orcamento.id}`
        const {data} = await http[verb](url, this.orcamento)
        console.log(data)
        if (data != null) {
          if (this.enviar_orcamento === true) {
            await http.post(`/orcamentos/send-orcamento/${data.orcamento.id}`)
            window.Materialize.toast('E-mail enviado com sucesso!!', 4000)
          }
          if (this.gerar_os === true && this.orcamento.status_id === 5) {
            this.$router.push({name: 'os.orcamento', params: {id: data.orcamento.id}})
          } else {
            this.$emit('update-orcamentos-list', {orcamento: data.orcamento})
            this.$router.push({name: 'orcamentos.index'})
          }
        }
      },
      onSelectCliente (item) {
        if (item) {
          this.setCliente(item.id)
        }
      },
      onSelectObjetivo (item) {
        if (item) {
          this.orcamento.titulo = item.titulo
          this.orcamento.objetivo = item.objetivo
          this.orcamento.resp_kitgas = item.resp_kitgas
          this.orcamento.resp_cliente = item.resp_cliente
          this.orcamento.disposicoes_finais = item.disposicoes_finais
        }
      },
      async setCliente (value) {
        this.orcamento.cliente_id = value
        if (value) {
          const {data} = await http.get(`/clientes/${value}`)
          this.$swal({
            title: `Deseja atualizar tipo de pessoa/razão social/rg/cpf/cnpj/ie e dados em branco com os dados do cliente ${data.cliente.cliente}?`,
            html: 'Caso os dados estejam errados é necessário atualizar a página',
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sim, quero atualizar!',
            reverseButtons: true
          }).then(async () => {
            this.orcamento.tipo = data.cliente.tipo
            this.orcamento.cnpj = data.cliente.cnpj
            this.orcamento.razao_social = data.cliente.razao_social
            this.orcamento.ie = data.cliente.ie
            this.orcamento.responsavel = this.orcamento.responsavel ? this.orcamento.responsavel : data.cliente.responsavel
            this.orcamento.cpf = data.cliente.cpf
            this.orcamento.rg = data.cliente.rg
            this.orcamento.email = this.orcamento.email ? this.orcamento.email : data.cliente.email
            this.orcamento.telefone = this.orcamento.telefone ? this.orcamento.telefone : data.cliente.telefone
            this.orcamento.telefone2 = this.orcamento.telefone2 ? this.orcamento.telefone2 : data.cliente.telefone2
            this.orcamento.telefone3 = this.orcamento.telefone3 ? this.orcamento.telefone3 : data.cliente.telefone3
            this.orcamento.cep = this.orcamento.cep ? this.orcamento.cep : data.cliente.cep
            this.orcamento.logradouro = this.orcamento.logradouro ? this.orcamento.logradouro : data.cliente.logradouro
            this.orcamento.numero = this.orcamento.numero ? this.orcamento.numero : data.cliente.numero
            this.orcamento.complemento = this.orcamento.complemento ? this.orcamento.complemento : data.cliente.complemento
            this.orcamento.bairro = this.orcamento.bairro ? this.orcamento.bairro : data.cliente.bairro
            this.orcamento.cidade = this.orcamento.cidade ? this.orcamento.cidade : data.cliente.cidade
            this.orcamento.estado = this.orcamento.estado ? this.orcamento.estado : data.cliente.estado
            this.orcamento.referencia = this.orcamento.referencia ? this.orcamento.referencia : data.cliente.referencia
            this.orcamento.localizacao_imagem = this.orcamento.localizacao_imagem ? this.orcamento.localizacao_imagem : data.cliente.localizacao_imagem
            this.orcamento.localizacao_mapa = this.orcamento.localizacao_mapa ? this.orcamento.localizacao_mapa : data.cliente.localizacao_mapa
            setTimeout(function () {
              window.Materialize.updateTextFields()
            }, 0)
          })
        }
      },
      clear () {
        this.orcamento = {
          id: '',
          cliente_id: '',
          orcamento: '',
          tipo: 1,
          cnpj: '',
          razao_social: '',
          ie: '',
          responsavel: '',
          cpf: '',
          rg: '',
          email: '',
          telefone: '',
          telefone2: '',
          telefone3: '',
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          referencia: '',
          blocos: '',
          visita: false,
          isometrico: '',
          visita_data: '',
          visita_hora: '',
          status_id: 1,
          localizacao_imagem: '',
          localizacao_mapa: '',
          propostas: [],
          fotos: [],
          videos: [],
          update_cliente: false,
          os_ids: [],
          documento_assinado: '',
          motivo_id: '',
          titulo: '',
          objetivo: '',
          resp_kitgas: '',
          resp_cliente: '',
          disposicoes_finais: ''
        }
      },
      addProposta () {
        this.orcamento.propostas.push({
          valor_total: 0,
          desconto: 0,
          pagamento_id: '',
          tempo_execucao: '',
          validade: 30,
          aprovado: false,
          servicos: [],
          produtos: [],
          grupos: []
        })
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 300)
      },
      destroyProposta (index) {
        this.$swal({
          title: 'Atenção',
          text: `excluir uma Proposta é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.orcamento.propostas[index].id) {
            this.orcamento.propostas.splice(index, 1)
            window.Materialize.toast('Proposta excluída!', 4000)
          } else {
            http.delete(`orcamentos/proposta/${this.orcamento.propostas[index].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Proposta excluída!', 4000)
                this.orcamento.propostas.splice(index, 1)
              })
          }
        })
      },
      onSelectServico (item) {
        if (item) {
          const servico = {
            servico_id: item.id,
            servico: item,
            qtd: 1,
            valor: item.valor,
            produtos: item.produtos
          }
          this.addServico(servico)
        }
      },
      onSelectGrupo (item) {
        if (item) {
          item.servicos.forEach((data) => {
            this.addServico({
              servico_id: data.servico.id,
              servico: data.servico,
              qtd: 1,
              valor: data.servico.valor,
              produtos: data.servico.produtos
            })
          })
        }
      },
      setPropostaIndex (index) {
        this.propostaIndex = index
      },
      async addServico (servico) {
        if (typeof this.orcamento.propostas[this.propostaIndex].servicos === 'undefined') {
          this.orcamento.propostas[this.propostaIndex].servicos = []
        }
        await this.orcamento.propostas[this.propostaIndex].servicos.push(servico)
        if (servico.produtos.length) {
          servico.produtos.forEach((data) => {
            if (data.produto) {
              this.addProduto({
                produto_id: data.produto_id,
                produto: data.produto,
                valor: data.produto.valor_venda,
                qtd: data.quantidade
              })
            }
          })
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyServico (indexProposta, indexServico) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um Serviço é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.orcamento.propostas[indexProposta].servicos[indexServico].id) {
            this.orcamento.propostas[indexProposta].servicos.splice(indexServico, 1)
            window.Materialize.toast('Serviço excluído!', 4000)
          } else {
            http.delete(`orcamentos/proposta/servico/${this.orcamento.propostas[indexProposta].servicos[indexServico].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Serviço excluído!', 4000)
                this.orcamento.propostas[indexProposta].servicos.splice(indexServico, 1)
              })
          }
        })
      },
      onSelectProduto (item) {
        if (item) {
          const produto = {
            produto_id: item.id,
            produto: item,
            valor: item.valor_venda,
            qtd: 1
          }
          this.addProduto(produto)
        }
      },
      async addProduto (produto) {
        if (typeof this.orcamento.propostas[this.propostaIndex].produtos === 'undefined') {
          this.orcamento.propostas[this.propostaIndex].produtos = []
        }
        await this.orcamento.propostas[this.propostaIndex].produtos.push(produto)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyProduto (indexProposta, indexProduto) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um Produto é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.orcamento.propostas[indexProposta].produtos[indexProduto].id) {
            this.orcamento.propostas[indexProposta].produtos.splice(indexProduto, 1)
            window.Materialize.toast('Produto excluído!', 4000)
          } else {
            http.delete(`orcamentos/proposta/produto/${this.orcamento.propostas[indexProposta].produtos[indexProduto].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Produto excluído!', 4000)
                this.orcamento.propostas[indexProposta].produtos.splice(indexProduto, 1)
              })
          }
        })
      },
      valor_proposta (index) {
        let valor = 0
        let desconto = this.orcamento.propostas[index].desconto
        if (typeof this.orcamento.propostas[index].servicos !== 'undefined') {
          this.orcamento.propostas[index].servicos.forEach(function (servico) {
            valor += parseFloat(servico.valor) * parseInt(servico.qtd)
          })
        }
        if (typeof this.orcamento.propostas[index].produtos !== 'undefined') {
          this.orcamento.propostas[index].produtos.forEach(function (produto) {
            valor += parseFloat(produto.valor) * parseInt(produto.qtd)
          })
        }
        return valor - desconto
      },
      totalProgress (progress, totalBytes, bytesSent) {
        this.progress = progress
      },
      complete (files, status, xhr) {
        if (files.errorMessage) {
          this.errorFile = true
        } else {
          this.errorFile = false
          this.orcamento.fotos.push({foto: xhr.response, legenda: '', ordem: ''})
          this.progress = 0
        }
      },
      complete2 (file, status, xhr) {
        if (file.errorMessage) {
          this.errorFile = true
        } else {
          this.errorFile = false
          file.addAttribute('id', xhr.response.id)
          this.orcamento.localizacao_imagem = xhr.response
          this.progress = 0
        }
      },
      totalProgress2 (progress, totalBytes, bytesSent) {
        this.progress = progress
      },
      complete3 (files, status, xhr) {
        if (files.errorMessage) {
          this.errorFile = true
        } else {
          this.errorFile = false
          this.orcamento.documento_assinado = xhr.response
          this.progress = 0
        }
      },
      destroyFoto (index, indexFoto) {
        this.$swal({
          title: 'Atenção',
          text: `excluir uma foto é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.orcamento.fotos[indexFoto].id) {
            this.orcamento.fotos.splice(indexFoto, 1)
            window.Materialize.toast('Foto excluída!', 4000)
          } else {
            http.delete(`orcamentos/foto/${this.orcamento.fotos[indexFoto].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Foto excluída!', 4000)
                this.orcamento.fotos.splice(indexFoto, 1)
              })
          }
        })
      },
      destroyVideo (index, indexVideo) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um video é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.orcamento.videos[indexVideo].id) {
            this.orcamento.videos.splice(indexVideo, 1)
            window.Materialize.toast('Video excluído!', 4000)
          } else {
            http.delete(`orcamentos/video/${this.orcamento.videos[indexVideo].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Video excluído!', 4000)
                this.orcamento.videos.splice(indexVideo, 1)
              })
          }
        })
      },
      destroyImage () {
        this.$swal({
          title: 'Atenção',
          text: `deseja excluir a imagem?`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          this.orcamento.localizacao_imagem = ''
        })
      },
      gerarLocalizacao () {
        this.orcamento.localizacao_mapa = `${this.orcamento.logradouro}, ${this.orcamento.numero} ${this.orcamento.bairro} ${this.orcamento.cidade} ${this.orcamento.estado} ${this.orcamento.cep}`
      },
      setAprovado (indexProposta) {
        this.orcamento.propostas.forEach((item, index) => {
          if (indexProposta !== index) {
            item.aprovado = false
          }
        })
      },
      deleteOs () {
        this.$swal({
          title: 'Atenção',
          text: `Essa ação apagará todas as OS's deste orçamento, é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          http.delete(`orcamentos/os/${this.orcamento.id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast('Operação concluída!', 4000)
              this.orcamento.os_ids = []
            })
        })
      },
      duplicarProposta (index) {
        this.$swal({
          title: 'Atenção',
          text: `Essa ação Duplicará o registro selecionado!`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero duplicar!',
          reverseButtons: true
        }).then(() => {
          let clone = cloneDeep(this.orcamento.propostas[index])
          if ('id' in clone) {
            delete clone.id
            clone.servicos.map((item) => {
              delete item.id
              delete item.proposta_id
              return item
            })
            clone.produtos.map((item) => {
              delete item.proposta_id
              delete item.id
              return item
            })
          }
          this.orcamento.propostas.push(clone)
          this.$nextTick(() => window.Materialize.updateTextFields())
        }).catch(this.$swal.noop)
      },
      addVideo () {
        if (this.video) {
          this.orcamento.videos.push({
            video: this.video
          })
          this.video = ''
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 300)
        }
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      isNew () {
        return this.orcamento.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      },
      url_app () {
        return process.env.API_URL
      }
    }
  }
</script>

<template>
  <div>

    <form>

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <ul class="collapsible popout" data-collapsible="accordion">
            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">people</i> Informações Gerais
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="input-field col s12 m6">
                    <list-select :list="clientes"
                                 option-value="id"
                                 option-text="cliente"
                                 :selected-item="itemCliente"
                                 placeholder="Buscar Cliente"
                                 @select="onSelectCliente">
                    </list-select>
                  </div>

                  <div class="col s12 m6" v-show="orcamento.cliente_id">
                    <div class="input-field col s12">
                      <input name="update_cliente" id="update_cliente" type="checkbox"
                             v-model="orcamento.update_cliente">
                      <label for="update_cliente">Atualizar Cliente com dados do orçamento</label>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="input-field col s12 m8">
                    <input name="responsavel" id="responsavel" type="text" v-model="orcamento.responsavel">
                    <label for="responsavel">Responsável</label>
                    <small class="red-text">{{ errors.first('responsavel') }}</small>
                  </div>
                  <div class="col s12 m4">
                    <label for="tipo">*Tipo</label>
                    <select name="tipo" id="tipo" v-validate data-vv-rules="required" :class="{invalid: errors.has('tipo')}" v-model.number="orcamento.tipo">
                      <option value="1">Pessoa Jurídica</option>
                      <option value="2">Pessoa Física</option>
                    </select>
                    <small class="red-text">{{ errors.first('tipo') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m4">
                    <input name="razao_social" id="razao_social" type="text" v-model="orcamento.razao_social">
                    <label for="razao_social">Razão Social</label>
                    <small class="red-text">{{ errors.first('razao_social') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="orcamento.tipo === 1">
                    <input name="cnpj" id="cnpj" type="text" v-mask="'99.999.999/9999-99'" v-validate
                           data-vv-rules="min:18" :class="{invalid: errors.has('cnpj')}" v-model="orcamento.cnpj">
                    <label for="cnpj">CNPJ</label>
                    <small class="red-text">{{ errors.first('cnpj') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="orcamento.tipo === 1">
                    <input name="ie" id="ie" type="text" :class="{invalid: errors.has('ie')}" v-model="orcamento.ie">
                    <label for="ie">Inscrição Estadual</label>
                    <small class="red-text">{{ errors.first('ie') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="orcamento.tipo === 2">
                    <input name="cpf" id="cpf" type="text" v-mask="'999.999.999-99'" v-validate
                           data-vv-rules="min:14" :class="{invalid: errors.has('cpf')}"
                           v-model="orcamento.cpf">
                    <label for="cpf">CPF</label>
                    <small class="red-text">{{ errors.first('cpf') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="telefone" id="telefone" type="text" v-mask="'(99) 99999999[9]'" v-validate
                           data-vv-rules="min:13" :class="{invalid: errors.has('telefone')}"
                           v-model="orcamento.telefone">
                    <label for="telefone">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone2" id="telefone2" type="text" v-mask="'(99) 99999999[9]'" v-validate
                           data-vv-rules="min:13" :class="{invalid: errors.has('telefone2')}"
                           v-model="orcamento.telefone2">
                    <label for="telefone2">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone2') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone3" id="telefone3" type="text" v-mask="'(99) 99999999[9]'" v-validate
                           data-vv-rules="min:13" :class="{invalid: errors.has('telefone3')}"
                           v-model="orcamento.telefone3">
                    <label for="telefone3">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone3') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="email" id="email" type="text" v-validate data-vv-rules="email"
                           :class="{invalid: errors.has('email')}" v-model="orcamento.email">
                    <label for="email">E-mail</label>
                    <small class="red-text">{{ errors.first('email') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="cep" id="cep" type="text" v-mask="'99999-999'" v-validate
                           data-vv-rules="min:9" :class="{invalid: errors.has('cep')}"
                           @blur="setEndereco" v-model="orcamento.cep">
                    <label for="cep">CEP</label>
                    <small class="red-text">{{ errors.first('cep') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="logradouro" id="logradouro" type="text"
                           v-model="orcamento.logradouro">
                    <label for="logradouro">Logradouro</label>
                    <small class="red-text">{{ errors.first('logradouro') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="numero" id="numero" type="text" v-model="orcamento.numero">
                    <label for="numero">Nº</label>
                    <small class="red-text">{{ errors.first('numero') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="complemento" id="complemento" type="text"
                           v-model="orcamento.complemento">
                    <label for="complemento">Compl.</label>
                    <small class="red-text">{{ errors.first('complemento') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m5">
                    <input name="bairro" id="bairro" type="text" v-model="orcamento.bairro">
                    <label for="bairro">Bairro</label>
                    <small class="red-text">{{ errors.first('bairro') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="cidade" id="cidade" type="text" v-model="orcamento.cidade">
                    <label for="cidade">Cidade</label>
                    <small class="red-text">{{ errors.first('cidade') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="estado" id="estado" type="text" v-model="orcamento.estado">
                    <label for="estado">Estado</label>
                    <small class="red-text">{{ errors.first('estado') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12">
                    <input name="blocos" id="blocos" type="text" v-model="orcamento.blocos">
                    <label for="blocos">Blocos (separados por ",")</label>
                    <small class="red-text">{{ errors.first('blocos') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12">
                    <input name="referencia" id="referencia" type="text" v-model="orcamento.referencia">
                    <label for="referencia">Ponto de Referência</label>
                    <small class="red-text">{{ errors.first('referencia') }}</small>
                  </div>
                </div>

                <div class="row">

                  <div class="col s12 m4">

                    <vue-clip :options="options" :on-complete="complete2" :on-total-progress="totalProgress">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <span class="card-title">Foto Localização</span>
                                <div class="center-align" style="height: 100px; width: 100%;">
                                  <img v-if="orcamento.localizacao_imagem"
                                       :src="`${api_url}/orcamentos/${orcamento.localizacao_imagem}`"
                                       style="max-width: 90%; max-height: 80px;">
                                  <div v-else>
                                    <img src="../../../assets/images/thumbupload.jpg"
                                         style="max-width: 90%; max-height: 50px;">
                                    <br clear="all"/>
                                    <small class="center-align">clique para inserir uma imagem</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress}%`"></div>
                            </div>
                            <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                            <div v-if="orcamento.localizacao_imagem" class="center-align"><i
                              class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i></div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>


                  <div class="input-field col s12 m8">
                    <input name="localizacao" id="localizacao" type="text" v-model="orcamento.localizacao_mapa">
                    <label for="localizacao">Mapa Localização</label>
                    <small class="red-text">{{ errors.first('localizacao_mapa') }}</small>

                    <button type="button" @click.prevent="gerarLocalizacao" class="waves-effect waves-light btn">Gerar
                      Localização
                    </button>

                  </div>
                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">date_range</i> Visita
              </div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="col s12">
                    <div class="input-field col s12">
                      <input name="visita" id="visita" type="checkbox" v-model="orcamento.visita">
                      <label for="visita">Visita</label>
                    </div>
                  </div>
                </div>

                <div class="row" v-show="orcamento.visita">

                  <div class="input-field col s12 m3">
                    <i class="material-icons prefix">event</i>
                    <input name="visita_data" id="icon_visita_data" type="date" v-validate="orcamento.visita === true ? 'required' : ''"
                           :class="{invalid: errors.has('visita_data')}" v-model="orcamento.visita_data"
                           :data-value="orcamento.visita_data">
                    <label for="icon_visita_data" class="active">*Data</label>
                    <small class="red-text">{{ errors.first('visita_data') }}</small>
                  </div>

                  <div class="col s12 m3">
                    <label for="visita_hora">Hora</label>
                    <select name="visita_hora" class="browser-default" id="visita_hora" v-model="orcamento.visita_hora" v-validate="orcamento.visita === true ? 'required' : ''" :class="{invalid: errors.has('visita_data')}">
                      <option value="">Selecione</option>
                      <option value="Manhã">Manhã</option>
                      <option value="Tarde">Tarde</option>
                      <option value="Noite">Noite</option>
                    </select>
                    <small class="red-text">{{ errors.first('visita_hora') }}</small>
                  </div>

                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">double_arrow</i> Objetivo
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="input-field col s12 m6">
                    <list-select :list="objetivos"
                                 option-value="id"
                                 option-text="titulo"
                                 :selected-item="itemObjetivo"
                                 placeholder="Buscar Objetivo"
                                 @select="onSelectObjetivo">
                    </list-select>
                  </div>

                </div>

                <div class="row">
                  <div class="input-field col s12">
                    <input name="titulo" id="titulo" type="text" :class="{invalid: errors.has('titulo')}"
                           v-model="orcamento.titulo"/>
                    <label for="titulo">*Título</label>
                    <small class="red-text">{{ errors.first('titulo') }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="objetivo" id="objetivo" type="text" class="materialize-textarea" v-model="orcamento.objetivo"></textarea>
                    <label for="objetivo">Objetivo</label>
                    <small class="red-text">{{ errors.first('objetivo') }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="resp_kitgas" id="resp_kitgas" type="text" class="materialize-textarea" v-model="orcamento.resp_kitgas"></textarea>
                    <label for="resp_kitgas">Responsabilidade Kit Gás</label>
                    <small class="red-text">{{ errors.first('resp_kitgas') }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="resp_cliente" id="resp_cliente" type="text" class="materialize-textarea" v-model="orcamento.resp_cliente"></textarea>
                    <label for="resp_cliente">Responsabilidade Cliente</label>
                    <small class="red-text">{{ errors.first('resp_cliente') }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="disposicoes_finais" id="disposicoes_finais" type="text" class="materialize-textarea" v-model="orcamento.disposicoes_finais"></textarea>
                    <label for="disposicoes_finais">Disposições Finais</label>
                    <small class="red-text">{{ errors.first('disposicoes_finais') }}</small>
                  </div>
                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">assignment_turned_in</i> Propostas
              </div>
              <div class="collapsible-body">

                <div class="row z-depth-1" v-for="(proposta, indexProposta) in orcamento.propostas">

                  <div class="col s12">

                    <div class="row">
                      <div class="input-field col s12" @click="setPropostaIndex(indexProposta)">
                        <list-select :list="grupos"
                                     option-value="id"
                                     option-text="grupo"
                                     :selected-item="item"
                                     placeholder="Adicionar Grupo de Serviços"
                                     @select="onSelectGrupo">
                        </list-select>
                      </div>
                    </div>

                    <div class="row">
                      <div class="input-field col s12" @click="setPropostaIndex(indexProposta)">
                        <list-select :list="servicos"
                                     option-value="id"
                                     option-text="servico"
                                     :selected-item="item"
                                     placeholder="Adicionar Serviço"
                                     @select="onSelectServico">
                        </list-select>
                      </div>
                    </div>

                    <div class="row" v-show="proposta.servicos && proposta.servicos.length > 0">
                      <div class="col s12">
                        <table class="responsive-table bordered highlight">
                          <tr>
                            <th>Serviços da Proposta</th>
                            <th>Qtd</th>
                            <th>Valor</th>
                            <th>Valor Total</th>
                            <th class="right-align">Excluir</th>
                          </tr>
                          <tr v-for="(servico, indexServico) in proposta.servicos">
                            <td>
                              <p>{{ (servico.servico) ? servico.servico.servico : '-' }}</p>
                            </td>
                            <td>
                              <input type="number" :id="`qtdServico${indexServico}`" v-model="servico.qtd" min="1"
                                     style="margin-bottom: 0">
                            </td>
                            <td>
                              <input type="number" :id="`valorServico${indexServico}`" v-model="servico.valor" min="1"
                                     style="margin-bottom: 0">
                            </td>
                            <td>
                              <input type="number" :id="`valorTotalServico${indexServico}`"
                                     :value="servico.valor * servico.qtd" style="margin-bottom: 0" readonly>
                            </td>
                            <td>
                              <div class="right-align">
                                <a href="#" @click.prevent="destroyServico(indexProposta, indexServico)">
                                  <i class="material-icons red-text">delete_forever</i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row">
                      <div class="input-field col s12" @click="setPropostaIndex(indexProposta)">
                        <list-select :list="produtos"
                                     option-value="id"
                                     option-text="produto"
                                     :selected-item="item"
                                     placeholder="Adicionar Produto"
                                     @select="onSelectProduto">
                        </list-select>
                      </div>
                    </div>

                    <div class="row" v-show="proposta.produtos && proposta.produtos.length > 0">
                      <div class="col s12">
                        <table class="responsive-table bordered highlight">
                          <tr>
                            <th>Produtos da Proposta</th>
                            <th>Qtd</th>
                            <th>Valor</th>
                            <th>Valor Total</th>
                            <th class="right-align">Excluir</th>
                          </tr>
                          <tr v-for="(produto, indexProduto) in proposta.produtos">
                            <td>
                              <p>{{ (produto.produto) ? produto.produto.produto : '-' }}</p>
                            </td>
                            <td>
                              <input type="number" :id="`qtdProduto${indexProduto}`" v-model="produto.qtd" min="1"
                                     style="margin-bottom: 0">
                            </td>
                            <td>
                              <input type="number" :id="`valorProduto${indexProduto}`" v-model="produto.valor" min="1"
                                     style="margin-bottom: 0">
                            </td>
                            <td>
                              <input type="number" :id="`valorTotalProduto${indexProduto}`"
                                     :value="produto.valor * produto.qtd" style="margin-bottom: 0" readonly>
                            </td>
                            <td>
                              <div class="right-align">
                                <a href="#" @click.prevent="destroyProduto(indexProposta, indexProduto)">
                                  <i class="material-icons red-text">delete_forever</i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row">

                      <div class="col s12 m6">
                        <label :for="`pagamento_id${indexProposta}`">*Condição de Pagamento</label>
                        <select :name="`pagamento_id${indexProposta}`" class="browser-default" :id="`pagamento_id${indexProposta}`" v-validate
                                data-vv-rules="required" v-model="proposta.pagamento_id">
                          <option v-for="pagamento in pagamentos" :value="pagamento.id">{{ pagamento.pagamento }}</option>
                        </select>
                        <small class="red-text">{{ errors.first('pagamento_id'+indexProposta) }}</small>
                      </div>

                      <div class="input-field col s12 m3">
                        <input :name="`desconto${indexProposta}`" :id="`desconto${indexProposta}`" type="number"
                               step="any" min="0" v-validate data-vv-rules="required"
                               :class="{invalid: errors.has(`desconto${indexProposta}`)}" v-model="proposta.desconto">
                        <label :for="`desconto${indexProposta}`">*Desconto</label>
                        <small class="red-text">{{ errors.first('desconto') }}</small>
                      </div>

                      <div class="input-field col s12 m3">
                        <input :name="`valor_total${indexProposta}`" :id="`valor_total${indexProposta}`" type="number"
                               step="any" min="0" v-validate data-vv-rules="required"
                               :class="{invalid: errors.has(`valor_total${indexProposta}`)}"
                               :value="valor_proposta(indexProposta)" readonly>
                        <label :for="`valor_total${indexProposta}`">*Valor Total</label>
                        <small class="red-text">{{ errors.first('valor_total') }}</small>
                      </div>

                    </div>

                    <div class="row">

                      <div class="input-field col s12 m3">
                        <input :name="`validade${indexProposta}`" :id="`validade${indexProposta}`" type="number"
                               step="any" min="0" v-model="proposta.validade">
                        <label :for="`validade${indexProposta}`">Validade da Proposta (dias)</label>
                        <small class="red-text">{{ errors.first('validade') }}</small>
                      </div>

                      <div class="input-field col s12 m3">
                        <input :name="`tempo_execucao${indexProposta}`" :id="`tempo_execucao${indexProposta}`"
                               type="text" v-model="proposta.tempo_execucao">
                        <label :for="`tempo_execucao${indexProposta}`">Tempo de Execução</label>
                        <small class="red-text">{{ errors.first('tempo_execucao') }}</small>
                      </div>

                      <div class="col s12 m3">
                        <div class="input-field col s12">
                          <input :name="`obs${indexProposta}`" :id="`obs${indexProposta}`" type="checkbox"
                                 v-model="proposta.aprovado" @click="setAprovado(indexProposta)">
                          <label :for="`obs${indexProposta}`">Aprovar Proposta</label>
                        </div>
                      </div>

                    </div>

                    <div class="row">

                      <div class="input-field col s12">

                        <label :for="`obs${indexProposta}`">Obs KitGás (não aparece na proposta)</label>
                        <textarea :name="`obs${indexProposta}`" :id="`obs${indexProposta}`" class="materialize-textarea"
                                  v-model="proposta.obs"></textarea>

                      </div>

                    </div>

                    <div class="row" v-show="proposta.servicos && proposta.servicos.length > 0">
                      <div class="col s12" v-for="(servico, indexServico) in proposta.servicos">
                        <label :for="`descricao${indexServico}`">Descrição do {{ servico.servico ?
                          servico.servico.servico : ''}}</label>
                        <quill-editor
                          @ready="onEditorChange($event, indexProposta, indexServico, servico.servico ? servico.servico.descricao: '')"
                          v-model="servico.descricao"
                          :content="servico.servico ? servico.servico.descricao : ''"
                          :options="editorDescricao">
                        </quill-editor>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col s12">
                        <div class="input-field col s12">
                          <input :name="`break_page${indexProposta}`" :id="`break_page${indexProposta}`" type="checkbox"
                                 v-model="proposta.break_page">
                          <label :for="`break_page${indexProposta}`">Forçar quebra de página PDF</label>
                        </div>
                      </div>
                    </div>

                    <div class="row">

                      <div class="input-field col s12 right-align">
                        <a href="#" @click.prevent="duplicarProposta(indexProposta)" class="btn blue darken-1">Duplicar</a>
                        <a href="#" @click.prevent="destroyProposta(indexProposta)" class="btn red">
                          Excluir Proposta
                        </a>
                      </div>

                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="input-field col s12 right-align">
                    <button type="button" class="waves-effect waves-light btn" @click=addProposta>Adicionar Proposta
                    </button>
                  </div>
                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">add_a_photo</i> Isométrico
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="col s12">

                    <vue-clip :options="options" :on-complete="completeIsometrico"
                              :on-total-progress="totalProgressIsometrico">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div class="center-align" style="height: 100px; width: 100%;">
                                  <img v-if="orcamento.isometrico"
                                       :src="`${api_url}/orcamentos/${orcamento.isometrico}`"
                                       style="max-width: 90%; max-height: 80px;">
                                  <div v-else>
                                    <img src="../../../assets/images/thumbupload.jpg"
                                         style="max-width: 90%; max-height: 50px;">
                                    <br clear="all"/>
                                    <small class="center-align">clique para inserir uma imagem</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress2}%`"></div>
                            </div>
                            <div v-if="errorFile2" class="center-align">Tipo de arquivo inválido</div>
                            <div v-if="orcamento.isometrico" class="center-align"><i class="material-icons pointer"
                                                                                     @click.prevent="destroyIsometrico()">delete_forever</i>
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>

                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">add_a_photo</i> Fotos
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="col s12 m4 center-align" v-for="(foto, indexFoto) in orcamento.fotos">
                    <img :src="`${api_url}/orcamentos/${foto.foto}`" style="max-width: 90%; height: 150px;"
                         class="pointer center-align"><br/>
                    <br/>
                    <label :for="`legenda${indexFoto}`">Legenda</label>
                    <textarea :name="`legenda{indexFoto}`" :id="`legenda{indexFoto}`" v-model="foto.legenda"
                              class="materialize-textarea"></textarea>
                    <a href="#" @click.prevent="destroyFoto(index, indexFoto)">
                      <i class="material-icons red-text">delete_forever</i>
                    </a>
                    <br clear="all"/>
                  </div>

                </div>

                <div class="row">

                  <div class="col s12">

                    <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div class="center-align" style="width: 100%;">
                                  <p class="center-align">clique para inserir imagens</p>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress}%`"></div>
                            </div>
                            <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>

                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">video_library</i> Vídeos
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="col s12 center-align" v-for="(video, indexVideo) in orcamento.videos">
                    <span v-html="video.video"></span>
                    <br/>
                    <a href="#" @click.prevent="destroyVideo(index, indexVideo)">
                      <i class="material-icons red-text">delete_forever</i>
                    </a>
                    <br clear="all"/>
                  </div>

                </div>

                <div class="row">

                  <div class="col s12">
                    <label>Embed Vídeo</label>
                    <textarea class="materialize-textarea" v-model="video"></textarea>
                    <button type="button" @click.prevent="addVideo" class="waves-effect waves-light btn">
                      Adicionar Vídeo
                    </button>
                  </div>

                </div>

              </div>

            </li>

            <li v-show="orcamento.os_ids.length > 0 && permissoes.indexOf('os.excluir') > -1">
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">build</i> OS's
              </div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="input-field col s12 m3" v-for="os in orcamento.os_ids">
                    <input name="os" id="os" type="text" :value="`#${os.id} - ${os.apartamento}`" disabled>
                    <label for="os">OS</label>
                  </div>

                </div>

                <div class="row">
                  <div class="col s12 m4">
                    <label for="status_os_id">*Status</label>
                    <select name="status_os_id" id="status_os_id" v-model="status_os_id">
                      <option value="">Todos os Status</option>
                      <option value="1">Novo</option>
                      <option value="2">Em andamento</option>
                      <option value="3">Finalizada</option>
                      <option value="4">Cancelada</option>
                    </select>
                    <small class="red-text">{{ errors.first('status_os_id') }}</small>
                  </div>
                </div>

                <div class="row" v-for="(n, index) in paginas" v-show="status_os_id === ''">
                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/oss?status=1&page=${n}`" class="white-text btn btn-large btn-block blue" target="_blank">
                      Imprimir Ordens de Serviço ({{ index * 30 + 1 }} - {{ ((n*30) < orcamento.os_ids.length) ? n * 30 : orcamento.os_ids.length }})
                    </a>
                  </div>
                </div>

                <div class="row" v-for="(n, index) in paginas1" v-show="status_os_id === '1'">
                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/oss?status=1&page=${n}`" class="white-text btn btn-large btn-block blue" target="_blank">
                      Imprimir Ordens de Serviço ({{ index * 30 + 1 }} - {{ ((n*30) < orcamento.os_ids.length) ? n * 30 : orcamento.os_ids.length }})
                    </a>
                  </div>
                </div>

                <div class="row" v-for="(n, index) in paginas2" v-show="status_os_id === '2'">
                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/oss?status=2&page=${n}`" class="white-text btn btn-large btn-block blue" target="_blank">
                      Imprimir Ordens de Serviço ({{ index * 30 + 1 }} - {{ ((n*30) < orcamento.os_ids.length) ? n * 30 : orcamento.os_ids.length }})
                    </a>
                  </div>
                </div>

                <div class="row" v-for="(n, index) in paginas3" v-show="status_os_id === '3'">
                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/oss?status=3&page=${n}`" class="white-text btn btn-large btn-block blue" target="_blank">
                      Imprimir Ordens de Serviço ({{ index * 30 + 1 }} - {{ ((n*30) < orcamento.os_ids.length) ? n * 30 : orcamento.os_ids.length }})
                    </a>
                  </div>
                </div>

                <div class="row" v-for="(n, index) in paginas4" v-show="status_os_id === '4'">
                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/oss?status=4&page=${n}`" class="white-text btn btn-large btn-block blue" target="_blank">
                      Imprimir Ordens de Serviço ({{ index * 30 + 1 }} - {{ ((n*30) < orcamento.os_ids.length) ? n * 30 : orcamento.os_ids.length }})
                    </a>
                  </div>
                </div>

                <div class="row">

                  <div class="col s12">
                    <button style="width: 100%" type="button" @click.prevent="deleteOs"
                            class="waves-effect waves-light btn red btn-large" :disabled="loading">Deletar Ordens de
                      Serviço
                    </button>
                  </div>

                </div>

              </div>

            </li>

            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">edit</i> Documento Assinado
              </div>
              <div class="collapsible-body">

                <div class="row" v-show="orcamento.documento_assinado">

                  <div class="col s12">
                    <a :href="`${url_app}/orcamento/${orcamento.id}/download`" class="blue-text" target="_blank">
                      <i class="material-icons left">file_download</i> Baixar Documento Assinado
                    </a>
                  </div>

                </div>

                <div class="row">

                  <div class="col s12">

                    <vue-clip :options="options2" :on-complete="complete3" :on-total-progress="totalProgress2">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <div class="center-align" style="width: 100%;">
                                  <p class="center-align">clique para inserir o documento assinado pelo cliente</p>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress}%`"></div>
                            </div>
                            <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>

                </div>

              </div>

            </li>

          </ul>

          <br clear="all"/>
          <hr/>
          <br clear="all"/>

          <div class="row">

            <div class="col s12 m4">
              <label for="status_id">*Status</label>
              <select name="status_id" id="status_id" v-validate data-vv-rules="required" v-model="orcamento.status_id">
                <option v-for="status in status" :value="status.id">{{ status.status }}</option>
              </select>
              <small class="red-text">{{ errors.first('status_id') }}</small>
            </div>

            <div class="col s12 m3" v-show="orcamento.status_id === 5">
              <div class="input-field col s12">
                <input name="gerar_os" id="gerar_os" type="checkbox" v-model="gerar_os">
                <label for="gerar_os">Gerar OS</label>
              </div>
            </div>

            <div class="col s12 m4" v-show="orcamento.status_id === 6">
              <label for="motivo_id">Motivo de Recusa</label>
              <select name="motivo_id" id="motivo_id" v-model="orcamento.motivo_id">
                <option v-for="motivo in motivos" :value="motivo.id">{{ motivo.motivo_recusa }}</option>
              </select>
              <small class="red-text">{{ errors.first('motivos') }}</small>
            </div>

            <div class="col s12 m3">
              <div class="input-field col s12">
                <input name="enviar_orcamento" id="enviar_orcamento" type="checkbox" v-model="enviar_orcamento">
                <label for="enviar_orcamento">Enviar por e-mail</label>
              </div>
            </div>

          </div>

          <div class="row">

            <div class="col s12">
              <button type="button" @click.prevent="validate" class="waves-effect waves-light btn" :disabled="loading">
                Salvar
              </button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/orcamentos/orcamentos/form.vue